<template>
  <!--the basic project (default) view-->
  <div class="container">
    <!--h4 class="block bg-sky-700 h-10 text-white text-lg">{{ name }}</h4-->
    <!--p class="debug">{{currentProject}}</p>-->
    <div v-if="loading">
      Project store is loading...
    </div>

    <MyForm  v-else :title="'Project Details'">
      <template v-slot:fields>
        <div v-if="debug" class="debug">
      <p>Debugging Project-details.vue...</p>
      <p>currentProject = {{ currentProject }}</p>
      <p>currentProject.customer = {{ currentProject.customer }}</p>
    </div>
        <!--
        <Form-input v-model="projectInfo.id" :readonly=true :disabled=true :name="'project id:'"></Form-input>
        <Form-input v-model="projectInfo.projectName" :readonly=true :disabled=true
          :name="'project name:'"></Form-input>
        <Form-input v-model="projectInfo.created_by" :readonly=true :disabled=true :name="'created by:'"></Form-input>
        <Form-input v-model="projectInfo.created_on" :readonly=true :disabled=true :name="'created on:'"></Form-input>
        <Form-input v-model="projectInfo.modified_on" :readonly=true :disabled=true :name="'modified on:'"></Form-input>-->
        <div class="container-hor">
          <div style="flex-grow: 1">
            <fieldset>
              <legend>Project status</legend>
              <ProjectStatus v-model:projectStatus="currentProject.status" :detailed_view="true"></ProjectStatus>
            </fieldset>
            
          </div>
          <div style="flex-grow: 3">
            <Project-division v-model:selected="currentProject.division" :disabled="true"></Project-division>
            <!--Project-source v-model:selected="currentProject.source"></Project-source-->
            <UserSelect
              v-model:selected="currentProject.owner_id"
              :name="'Owner:'"
              :role="'owner'"
              :includeArchived="true"
            ></UserSelect>
            <UserSelect
              v-model:selected="currentProject.engineer_id"
              :name="'Engineer:'"
              :role="'engineer'"
              :includeArchived="true"
            ></UserSelect>
            <UserSelect
              v-model:selected="currentProject.drafter_id"
              :name="'Drafter:'"
              :role="'drafter'"
              :includeArchived="true"
            ></UserSelect>
            <Form-input
              v-model="currentProject.description"
              :name="'description:'"
              :placeholder="'only needed where multiple projects share same address'"
            ></Form-input>
            <!--CustomerSelect v-model:selected="projectInfo.customerId"></CustomerSelect-->
            <CustomerListbox v-model:customer="currentProject.customer" :key="customerKey"></CustomerListbox>
            <FormTextArea v-model="currentProject.notes" :name="'notes:'"></FormTextArea>

            <!--Form-input v-model="projectInfo.photosLink" :readonly=true :disabled=true
              :name="'google photos link:'" :placeholder="'delete this field'"></Form-input>-->
          </div>
        </div>

        <Suspense>
          <template #default>
            <Project-location
              v-model:projectName="currentProject.name"
              v-model:streetAddress="currentProject.streetAddress"
              v-model:city="currentProject.city"
              v-model:province="currentProject.province"
              v-model:gps="currentProject.gps"
              @updateGPS="reloadLocation"
              :key="locationKey"
            >
            </Project-location>
         </template>
         <template #fallback>
            <p>fetching location data...</p>
         </template>
        </Suspense>

        <div class="container-hor">
          <div class="checkbox-container">
            <ScopesCheckbox v-model:projectScopes="currentProject.scopes"></ScopesCheckbox>
          </div>
          <div class="checkbox-container">
            <!--ProjectTags v-model:projectTags="projectInfo.tags"></ProjectTags-->
            <TagCreate v-model:projectTags="currentProject.tags"></TagCreate>
          </div>
        </div>
      </template>

      <template v-slot:buttons>
        <div class="btn-footer">
          <div v-if="watchlist">
            <FormBtn
              v-if="watchlist.isWatched(currentProject.id)"
              :name="'Remove from Watchlist'"
              @clicked="watchlist.remove(currentProject.id)"
            >
            </FormBtn>
            <FormBtn
              v-else
              :name="'Add to Watchlist'"
              @clicked="watchlist.add(currentProject.id)"
            ></FormBtn>
          </div>
          <FormBtn :name="'Save Changes'" @clicked="submitForm"></FormBtn>
          <FormBtn :name="'Revert Changes'" @clicked="revertForm"></FormBtn>
        </div>
      </template>

      <!--p>projectInfo = {{ projectInfo }}</p>-->
    </MyForm>
  </div>

  <!-- end of basic project view -->
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
//import { loadingStart, loadingEnd } from '@/js/common.js'
import ProjectLocation from '@/components/Project-location.vue'
//import { ProjectSource } from '@/components'
import { MyForm, UserSelect, FormBtn, FormInput, FormTextArea } from '@/components/form'
//import { Province } from "@/types/types";
import CustomerListbox  from '@/components/Customer-listbox.vue';
import ScopesCheckbox from '@/components/Project-scopes.vue'
import ProjectStatus from '@/components/Project-status.vue'
//import ProjectTags from '@/components/Project-tags.vue'
//import type { Project, Customer } from '@/types/types.js'
import { useProjectStore, useWatchlistStore, useAlertStore } from '@/stores/'
import TagCreate from '@/components/Tag-create.vue'
//import { storeToRefs } from 'pinia';
import { fetchGPS } from '@/libs/climatic';
import { useRoute } from 'vue-router';
import { useCurrentProject } from '@/composables/Current-project';
import router from '@/router';
import ProjectDivision  from '@/components/Project-division.vue';

const debug = ref(false);
const alert = useAlertStore()
const watchlist = useWatchlistStore()
const route = useRoute();
//const { isWatched } = storeToRefs( watchList );


/*
const props = defineProps({
  projectId: Number,
  //folderUrl: String,
});*/
const locationKey = ref(1) //used to rerender the location component when gps is updated
function reloadLocation() {
  console.log('reloading project location component...')
  locationKey.value += 1
  submitForm()
}

const projects = useProjectStore()
//const { currentProject } = storeToRefs(projects);
const { currentProject, loading } = useCurrentProject();
/*const currentProject = computed(()=>{
  const projectId = route.params.projectId;
  return projects.getById(projectId);
})*/
//const project = await projects.currentProject
/*const projectInfo = computed<ProjectInfo>(()=>{
  return currentProject.value.projectInfo;
});*/
//const projectInfo = ref<ProjectInfo>(project.projectInfo)
const customerKey = ref(1);
watch(currentProject,()=>{
  customerKey.value+=1;
})


//force fetch project from backend, store contains changes we need to revert
async function revertForm() {
  console.log('Project-basic form being reverted to original values...')
  router.push(`/projects/${currentProject.value.id}/details`)
  //const project = await projects.getById(props.projectId)
  //project.value = await projects.currentProject;
  //console.log("..printing project = " + JSON.stringify(project));
  /*const projectId = projectInfo.value.id;
  console.log("...projectId = " + projectId);
  await projects.setCurrentProject(projectId);
  const currProj = await projects.currentProject*/
  //projectInfo.value = currProj.projectInfo;
  //locationKey.value += 1
  //reloadLocation();

}

//TODO validate form before submit
async function submitForm() {
  console.log('Project-basic form submit...')

  //search for GPS if not manually done before creating project
  const lat = currentProject.value.gps.lat;
  const lon = currentProject.value.gps.lon;
  if(lat == -1 || lon == -1 || lat == -2 || lon == -2){
    try{
      const address = currentProject.value.streetAddress + ', ' + currentProject.value.city + ', ' + currentProject.value.province;
      currentProject.value.gps = await fetchGPS(address)

    }catch(error){
      console.log("..error in fetchGPS...");
      console.log(error);
      //currentProject.gps.value = {'lat': -2, 'lon': -2};
    }
  }

  try {
    console.log(JSON.stringify(currentProject.value))
    currentProject.value.customer_id = currentProject.value.customer.id;
    await projects.writeChanges(currentProject.value)
  } catch (error) {
    console.log(error)
  }


}

//update customerId to match customer.id
watch(currentProject.value.customer, ()=>{
  currentProject.value.customer_id = currentProject.value.customer.id;
})


</script>

<style lang="css" scoped>
.checkbox-container {
  flex-grow: 1;
  /* height:20rem;
  max-height: 24rem;*/
}
</style>
